import React from 'react';

import classes from './FormCard.module.scss';

const FormCard = ({ className, classContent, subtitle, description, children }) => {
  const containerClasses = [classes.container];
  if (className) {
    containerClasses.push(className);
  }

  return (
    <div className={containerClasses.join(' ')}>
      <div className={classes.head}>
        {subtitle && <span className={`${classes.subtitle} bold-24`}>{subtitle}</span>}
        {description && <span className={`${classes.description} medium-16`}>{description}</span>}
      </div>
      <div className={`${classContent} card-formGrid`}>{children}</div>
    </div>
  );
};

export default FormCard;
